// extracted by mini-css-extract-plugin
export default {"container":"PayeeAccountMenu_container__hByrh","payeeName":"PayeeAccountMenu_payeeName__4x2Mf"};